import { z } from 'zod';
import { requiredString } from '../helpers';
export const Hubspot_Book_Meeting_1_ConfigValidator = z.object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    meetingSlug: requiredString('Meeting slug is required'),
    attendeeFirstName: requiredString('Attendee first name is required'),
    attendeeLastName: requiredString('Attendee last name is required'),
    attendeeEmail: requiredString('Attendee email is required'),
    timezone: requiredString('Timezone is required'),
    durationMinutes: z.number().int().positive('Duration must be a positive integer (minutes)'),
    startTime: requiredString('Start time is required')
});
//# sourceMappingURL=hubspot-book-meeting-1.js.map